/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.controllers {
    export interface ITestMemoryScope extends angular.IScope {
        model: Wars.Domain.Model.Dtos.TestMemoryConsumptionDto;
        beforeProcessInfo: string;
        afterProcessInfo: string;
        processInfo: string;
        getProcessInfo: () => void;
        test: () => void;
        clear: () => void ;
    }

    export class TestMemoryController implements IController {
        constructor(
            private $scope: ITestMemoryScope,
            private testService: services.TestService)
        {
            $scope.test = () => this.test();
            $scope.clear = () => this.clear();
            $scope.getProcessInfo = () => this.getProcessInfo();
            $scope.model = <Wars.Domain.Model.Dtos.TestMemoryConsumptionDto>{};
        }

        private test() : void {
            this.testService.getProcessInfo().then((processInfo) => {
                this.$scope.beforeProcessInfo = processInfo;
            });
            this.testService.testMemoryFootprint(this.$scope.model).then((processInfo) => {
                this.$scope.afterProcessInfo = processInfo;
            });
        }

        private clear(): void {
            this.testService.clearTestItemsFromMemory().then((processInfo) => {
                this.$scope.beforeProcessInfo = undefined;
                this.$scope.afterProcessInfo = undefined;
                this.$scope.processInfo = processInfo;

            });
        }

        private getProcessInfo(): void {
            this.testService.getProcessInfo().then((processInfo) => {
                this.$scope.processInfo = processInfo;
            });
        }
    }
}

warsApp.registerController("TestMemoryController", ["$scope", "testService"]);